module.exports = __webpack_public_path__ + "static/img/envelope03khm.5017caa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope03khm.png
// module id = x2KH
// module chunks = 1